module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/pictogram-skyscrapers-bb8ce422512a62ea19eae726d57cc7bc.svg";